<script setup lang="ts">
import { useForm } from "@soft-db/form";
import { useApi } from "@soft-db/monitoring-api-client";
import { Button, FormField, TextInput } from "@soft-db/ui";

const { useField, valid, handleSubmit } = useForm<{ email: string }>({ mode: "default" });
const email = useField("email", { isRequired: true, isEmail: true });

const auth = useApi().auth();
const loading = ref(false);
const emailSent = ref(false);
const resetError = ref(false);

const sendResetEmail = handleSubmit(async () => {
	loading.value = true;

	try {
		await auth.resetPasswordRequest(email.data.value || "");
		emailSent.value = true;
	} catch {
		resetError.value = true;
	}

	loading.value = false;
});

const router = useRouter();
const goToAuthPage = () => {
	router.push({ name: "auth-login" });
};
</script>

<template>
	<div class="flex h-full flex-col gap-2">
		<template v-if="!emailSent && !resetError">
			<div class="grow text-center">
				<h3 class="mt-2">{{ $t("auth.forgotCaption") }}</h3>
			</div>
			<FormField :label="$t('common.email')" :errors="email.errors.value">
				<TextInput
					v-model="email.data.value"
					class="bg-current/20 text-primary-content w-full"
					type="email"
				/>
			</FormField>
			<Button
				color="default"
				:disabled="!valid || !email.data.value"
				:loading="loading"
				@click="sendResetEmail"
			>
				{{ $t("group-settings.resetPassword") }}
			</Button>
		</template>
		<template v-else-if="emailSent && !resetError">
			<h3>{{ $t("auth.forgotSent") }}</h3>
		</template>
		<template v-else>
			<h3>{{ $t("auth.forgotSentError") }}</h3>
		</template>
		<Button class="mx-auto mt-4 w-44" color="default" @click="goToAuthPage">
			{{ $t("auth.back") }}
		</Button>
	</div>
</template>
